import { getLocations } from "../api/locations";

export const grabLocations = async (): Promise<any> => {

    const apiResults = await getLocations();

    console.log(apiResults.data);

    return apiResults.data;

}